
import { useCookies } from 'react-cookie'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { userStateData } from '../../data/userStateData'
import './style.scss'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { setShowPreview } from '../../redux/reducers/toolSlice'

interface DashboardToolHeaderProps {
	title: string
}

function DashboardToolHeader({title}: DashboardToolHeaderProps) {

	const [cookies, setCookie, removeCookie] = useCookies(['userData'])
	const showPreview: boolean = useAppSelector(state => state.tool.showPreview)
	const dispatch = useAppDispatch()

	const logoutClickHandler = () => {
		userStateData.logOut()
		removeCookie("userData",{
			path: "/"
		})
		window.location.replace(PAGE_URLS.APP_ENTRY)
	}

	const previewClickHandler = () => {
		dispatch(setShowPreview(showPreview == false))
	}

	return (
		<div className='dashboard-tool-header-wrap'>
			<div className='dashboard-tool-header-logo-wrap'>
				<img 
					className='dashboard-tool-header-logo-img'
					src='/imgs/logos/logo-micro-white.svg'
					alt='Micro Logo'
				/>
			</div>
			<div className='dashboard-tool-header-title'>
				{title}
			</div>
			<div
				className='dashboard-tool-header-button'
				onClick={() => previewClickHandler()}
			>
				{showPreview ? 'Stop Preview' : 'Show Preview'}
			</div>
			<div
				className='dashboard-tool-header-button'
				onClick={() => logoutClickHandler()}
			>
				Save Draft
			</div>
			<div
				className='dashboard-tool-header-button dashboard-tool-header-button-alt'
				onClick={() => logoutClickHandler()}
			>
				Publish Feedback
			</div>
		</div>
	)
}

export default DashboardToolHeader